import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Download, Award } from "lucide-react";
import { API } from "../lib/api";

export default function Certificate() {
  const { token } = useParams();
  const [status, setStatus] = useState("ready"); // ready | error
  const pdfUrl = `${API}/certificate/${token}`;

  if (status === "error") {
    return (
      <div className="max-w-xl mx-auto px-6 py-32 text-center">
        <div className="font-display text-3xl text-[#2D2A26]">Certificate not found</div>
        <p className="text-[#5C5852] mt-4">This link may have expired or been mistyped.</p>
        <Link to="/dashboard" className="text-[#A36B5E] mt-6 inline-block">Back to your dashboard →</Link>
      </div>
    );
  }
  return (
    <div className="max-w-5xl mx-auto px-6 py-16">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#A36B5E]/10 mb-5">
          <Award size={32} className="text-[#A36B5E]" />
        </div>
        <div className="text-xs uppercase tracking-[0.25em] text-[#A36B5E]">Certificate of Completion</div>
        <h1 className="font-display text-5xl text-[#2D2A26] mt-3 tracking-tight" data-testid="certificate-title">
          You finished the journey.
        </h1>
        <p className="text-[#5C5852] mt-6 text-lg max-w-xl mx-auto leading-relaxed">
          All nine lessons of Divine Alignment are complete. Below is your certificate — yours to download, print, or share.
        </p>
        <a
          href={pdfUrl}
          download
          data-testid="certificate-download"
          className="btn-primary rounded-full px-8 py-4 mt-8 inline-flex items-center gap-2 font-medium"
        >
          <Download size={18} /> Download PDF
        </a>
      </div>

      <div className="bg-white border border-[#EAE5D9] rounded-2xl overflow-hidden shadow-[0_20px_60px_-15px_rgba(0,0,0,0.15)]">
        <iframe
          src={pdfUrl}
          title="Certificate of Completion"
          className="w-full"
          style={{ height: "70vh", minHeight: "600px" }}
          onError={() => setStatus("error")}
          data-testid="certificate-iframe"
        />
      </div>

      <div className="text-center mt-10 italic text-[#5C5852]">
        "He will make your paths straight." — Proverbs 3:6
      </div>
    </div>
  );
}
